import React from 'react';
import { InfoIcon, SVGWrapper } from '../svg';
import styles from './styles.module.css';

interface Props {
  text: string;
}

export const ExampleComponent = ({ text }: Props) => {
  return (
    <React.Fragment>
      <div className={styles.test}>Example Component:: {text}</div>
      <SVGWrapper size="48px" color="red" label="heart-icon">
        <InfoIcon />
      </SVGWrapper>
    </React.Fragment>
  );
};
